import React from 'react';

import { Form, Formik, FormikProps } from 'formik';

import SearchFieldAuto from '@app/components/UI/Forms/SearchField/SearchFieldAuto';
import { SidebarProps } from '@app/objects/SidebarProps';

import '@app/scss/components/blockSideBar.scss';

const Sidebar: React.FC<SidebarProps> = ({
	searchFieldName,
	searchFieldPlaceHolder,
	withSubmit,
	submitCaption,
	typeButton = 'submit',
	setStateSelected,
	stateSelected,
	setVetId,
	setVetName,
	setVetNameShort,
	vetFieldValue,
	setVetFieldValue,
	stateListOptions,
	vetListOptions,
	vetNameListOptions,
	setCardsCount,
	onSubmit,
	initCardsCount,
	vetName,
}) => {
	const clearSelected = (formikBag) => {
		setStateSelected && setStateSelected('');
		setVetId && setVetId('');
		setVetName && setVetName('');
		setVetNameShort && setVetNameShort('');
		setCardsCount && initCardsCount && setCardsCount(initCardsCount);
		setVetFieldValue && setVetFieldValue('');
		formikBag.resetForm(formikBag.initialValues);
	};

	return (
		<div className="block__sidebar">
			<Formik
				onSubmit={() => onSubmit && onSubmit()}
				initialValues={{ state: stateSelected || '', vetById: vetFieldValue || '', vetByName: vetName || '' }}
				enableReinitialize
			>
				{(formikBag: FormikProps<any>) => {
					return (
						<Form autoComplete="off">
							<SearchFieldAuto
								name={searchFieldName}
								placeholder={searchFieldPlaceHolder}
								listOptions={vetNameListOptions}
								formikBag={formikBag}
								onSelect={(value, option) => {
									setVetName && setVetName(option.value.slice(4));
								}}
								onChange={(value, option) => {
									formikBag.setFieldValue(searchFieldName, value);
									setVetNameShort && setVetNameShort(value);
								}}
								onSearch={() => {
									setVetName && formikBag.values[searchFieldName].substring(0, 4) === 'Dr. '
										? setVetName(formikBag.values[searchFieldName].slice(4))
										: setVetName && setVetName(formikBag.values[searchFieldName]);
								}}
								searchButton
							/>
							<div className="block__sidebar-nav">
								<div className="block__sidebar-nav-filter">
									<h4 className="block__sidebar-nav-filter-title">Filter by state</h4>
									<SearchFieldAuto
										name="state"
										placeholder="Select a state"
										listOptions={stateListOptions}
										formikBag={formikBag}
										onSelect={(value, option) => {
											setStateSelected && setStateSelected(value);
											setVetName && setVetName('');
											setVetId && setVetId('');
											setVetFieldValue && setVetFieldValue('');
											setVetNameShort && setVetNameShort('');
											formikBag.setFieldValue('vetById', '');
											formikBag.setFieldValue('vetByName', '');
										}}
										onChange={(value) => {
											formikBag.setFieldValue('state', value);
										}}
										searchButton={false}
									/>
									{!formikBag.values.vetByName && (
										<>
											<h4 className="block__sidebar-nav-filter-title">Filter by veterinarian</h4>
											<SearchFieldAuto
												name="vetById"
												placeholder="Select veterinarian"
												listOptions={vetListOptions}
												formikBag={formikBag}
												onSelect={(value, option) => {
													setVetId && setVetId(String(option?.id || ''));
												}}
												onChange={(value, option) => {
													setVetId && setVetId('');
													formikBag.setFieldValue('vetById', value);
													setVetFieldValue && setVetFieldValue(value);
												}}
												searchButton={false}
											/>
										</>
									)}
								</div>
								{withSubmit && (
									<>
										<div className=" block__sidebar-nav-clear">
											<button type="reset" onClick={() => clearSelected(formikBag)} className="btn btn-secondary">
												Clear all filters
											</button>
										</div>
										{typeButton === 'submit' ? (
											<button type="submit" className="btn btn-primary btn-submit">{submitCaption}</button>
										) : (
											<button type={typeButton} className="btn btn-primary btn-submit" onClick={onSubmit}>{submitCaption}</button>
										)}
									</>
								)}
							</div>
						</Form>
					);
				}}
			</Formik>
		</div>
	);
};

export default Sidebar;
